import { Injectable } from '@angular/core'
import { CanActivate } from '@angular/router'
import { NbAuthService } from '@nebular/auth'

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: NbAuthService) {}

  canActivate() {
    return this.authService.isAuthenticated()
  }
}
